/**
 * bhiTranslations.js — iter842 (Feb 2026)
 *
 * Extracted from BreastHealthIntelligencePage.jsx (was ~200 inline lines).
 * Holds the multi-language dictionary (bg / en / es) for all UI copy on
 * the Breast Health Intelligence page.
 *
 * Consumer usage:
 *   import { BHI_TRANSLATIONS } from "@/components/breast_intel/bhiTranslations";
 *   const t = BHI_TRANSLATIONS[lang] || BHI_TRANSLATIONS.bg;
 */

export const BHI_TRANSLATIONS = {
  bg: {
    title: "Метаболитен профил на гръдна тъкан",
    subtitle: "Персонализиран анализ, който показва как различни процеси в организма могат да влияят върху здравето на гърдите. Обединява информацията за Вашите заболявания, лабораторни резултати, хранене и 20 дигитални здравни модела в една лесна за разбиране интерактивна карта. Анализът има образователна и информационна цел и не представлява медицинска диагноза.",
    description:
      "Персонализиран анализ, който показва как различни процеси в организма могат да влияят върху здравето на гърдите. Обединява информацията за Вашите заболявания, лабораторни резултати, хранене и 20 дигитални здравни модела в една лесна за разбиране интерактивна карта. Анализът има образователна и информационна цел и не представлява медицинска диагноза.",
    back: "Health Intelligence",
    loginCta: "Влезте за достъп до модула",
    loginCtaText: "Модулът изисква защитен потребителски акаунт за опазване на здравните данни.",
    loginBtn: "Вход",
    registerBtn: "Регистрация",
    sections: {
      biology:       "Тъканни среди (образователен индекс)",
      density:       "Плътност на тъканта (ръчно въведен BI-RADS)",
      metabolic:     "Метаболитен профил",
      benign:        "Доброкачествени състояния",
      molecular:     "Молекулярни пътища (образователно)",
      geno_lab:      "🧬 Генетичен профил",
      tissue_plan:   "🌿 План за оптимизация на средата",
      prevention:    "🎯 12-месечна програма за подкрепа",
      coach:         "🤝 AI помощник",
      interventions: "Персонализирани препоръки",
      tissue_age:    "Ориентировъчна метаболитна възраст",
      ecosystem:     "Карта на екосистемата",
      speclab:       "🧪 Детоксикация и генетика (DUTCH / ДНК)",
    },
    phases: {
      assess:        "Опознаване — кой съм аз",
      assess_sub:    "Базов риск, наследственост и обобщен индекс",
      observe:       "Наблюдение — какво е сега",
      observe_sub:   "Тъканни среди, плътност (при въведен BI-RADS), метаболитен профил",
      understand:    "Разбиране — какво се случва биологично",
      understand_sub:"Активни молекулярни пътища и биологични асоциации (образователно)",
      plan:          "План — какво да правя",
      plan_sub:      "Краткосрочно възстановяване и 12-месечна стратегия",
      act:           "Действие — как съм всеки ден",
      act_sub:       "Динамичен месечен помощник и дневни/седмични препоръки",
      support:       "Подкрепа — допълнителни инструменти",
      support_sub:   "BC-friendly меню и интерактивна карта на екосистемата",
    },
    biologyHelp: "6 анатомични среди — образователен индекс на метаболитните/възпалителните сигнали, които влияят върху всяка от тях. Не измерва тъкан.",
    biologyHelpPlain: "6 области на гърдата — показва кои процеси в тялото могат да влияят върху всяка от тях. НЕ измерва самата тъкан.",
    densityHelp: "BI-RADS A–D категория от Вашия мамографски доклад (ръчно въведена). Софтуерно/AI разпознаване на плътност НЕ се прави. Стойността захранва обобщения индекс.",
    densityHelpPlain: "Гъстотата на гърдата от мамограмата (A, B, C или D). Въвеждате я ръчно от заключението на прегледа.",
    metabolicHelp: "Обобщен Метаболитен профил (индекс 0–100) от пет под-среди: инсулинова, IGF-1, възпалителна, естрогенна, адипозна. Образователен, не диагностичен.",
    metabolicHelpPlain: "Обобщена оценка (0–100) на 5 процеса в тялото Ви: захар, растежен фактор, възпаление, естроген, мазнини. Образователна, не диагноза.",
    benignHelp: "Образователни табла за петте най-чести доброкачествени състояния с персонализирани препоръки.",
    molecularHelp: "Седем основни биологични сигнални пътя — естрогенен, инсулин/IGF-1/mTOR, възпалителен NF-κB, оксидативен, тиреоиден, метаболизъм на липидите (PPAR/SREBP), витамин D (VDR). Образователни оценки, не диагностика.",
    molecularHelpPlain: "7 биологични процеса, които се съобщават с клетките — естроген, инсулин/растеж, възпаление, оксидативен стрес, щитовидна жлеза, мазнини, витамин D. Образователно.",
    interventionsHelp: "Препоръки с ниво на доказателство (A/B/C). Образователни — обсъждайте със Вашия лекар преди значими промени.",
    interventionsHelpPlain: "Препоръки с оценка колко силни са научните доказателства (A = силни, B = средни, C = слаби). Винаги говорете с лекаря си преди сериозни промени.",
    tissueAgeHelp: "Ориентировъчен индекс — доколко метаболитната Ви среда се отклонява от хронологичната Ви възраст. Не е измерване на тъканта.",
    tissueAgeHelpPlain: "Приблизителна оценка — доколко процесите в тялото Ви са в темпо с реалната Ви възраст. Не е измерване на самата тъкан.",
    ecosystemHelp: "Каскада на биологичните пътища, на които начинът на живот влияе и които накрая се отразяват на средата на гръдната тъкан.",
    ecosystemHelpPlain: "Карта, показваща как навиците и хранетието влияят стъпка по стъпка на процесите в гърдата.",
    evidenceA: "Високо ниво на доказателство",
    evidenceB: "Умерено ниво",
    evidenceC: "Базово/мнение на експерти",
    nutrition: "Хранене",
    mindbody: "Тяло и Ум",
    activity: "Физическа активност",
    supplements: "Добавки",
    score: "Индекс",
    factors: "Сигнали, които може да променим",
    nis_avg: "Среден NIS",
    dil_avg: "Среден DIL",
    meals: "хранения",
    last_14: "последни 14 дни",
    bmi: "BMI",
    age: "Възраст",
    disclaimerTitle: "Научен и медицински статус",
    statusBands: { green: "Нисък натиск", yellow: "Умерен натиск", orange: "По-висок натиск", red: "Висок натиск — обсъдете с лекар" },
    selectZone: "Изберете зона за подробности",
    refresh: "Обнови данните",
    bottomLink: "Към инструментите (Risk Profile, BMI, AI мамография) — образователни →",
  },
  en: {
    title: "Breast Health Intelligence",
    subtitle: "An educational digital twin of breast health — 6 tissue environments, metabolic intelligence, and personalised interventions",
    description:
      "Integrates nutrition, metabolic health, lifestyle, breast biology and density into a single educational experience. Educational and preventive tool. Not intended for diagnosis, treatment, or prediction of breast cancer.",
    back: "Health Intelligence",
    loginCta: "Sign in to access the module",
    loginCtaText: "Breast Health Intelligence requires a secured user account to protect health data.",
    loginBtn: "Sign in",
    registerBtn: "Register",
    sections: {
      biology:       "Breast Tissue Biology",
      density:       "Density Intelligence",
      metabolic:     "Metabolic Environment",
      benign:        "Benign Conditions",
      molecular:     "Molecular Pathways (educational)",
      geno_lab:      "🧬 Breast Disease Intelligence",
      tissue_plan:   "🌿 Breast Tissue Restoration Plan",
      prevention:    "🎯 12-Month Prevention Program",
      coach:         "🤝 Breast Health Coach AI",
      interventions: "Personalised Interventions",
      tissue_age:    "Breast Environment Age",
      ecosystem:     "Ecosystem Map",
      speclab:       "🧪 Detoxification & Genetics (DUTCH / DNA)",
    },
    phases: {
      assess:        "Assess — who am I",
      assess_sub:    "Baseline risk, hereditary signals and the composite BHI score",
      observe:       "Observe — where I am right now",
      observe_sub:   "Tissue biology, density, metabolic environment and tissue age",
      understand:    "Understand — what is happening biologically",
      understand_sub:"Active molecular pathways and biological associations with 23 conditions",
      plan:          "Plan — what to do",
      plan_sub:      "Short-term restoration plan and 12-month strategy",
      act:           "Act — how I show up daily",
      act_sub:       "Dynamic monthly coach and daily/weekly interventions",
      support:       "Support — extra tools",
      support_sub:   "BC-friendly menu and interactive ecosystem map",
    },
    biologyHelp: "6 anatomical environments — an educational index of the metabolic/inflammatory factors that influence each. NOT a tissue measurement.",
    densityHelp: "BI-RADS A–D category from your radiologist mammography report (manual entry). NO software/AI density auto-detection.",
    metabolicHelp: "Composite Breast Metabolic Score (0–100) from five sub-environments: insulin, IGF-1, inflammation, estrogen, adiposity.",
    benignHelp: "Educational dashboards for the five most common benign conditions with personalised recommendations.",
    molecularHelp: "Four major biological signalling pathways — estrogen, insulin/IGF-1/mTOR, NF-κB inflammation, oxidative. Educational estimates, not diagnostic.",
    interventionsHelp: "Recommendations with evidence level (A/B/C). Educational — discuss with your physician before major changes.",
    tissueAgeHelp: "Educational metric — how much 'older' or 'younger' your metabolic environment is compared to your chronological age.",
    ecosystemHelp: "Cascade of biological pathways that lifestyle influences and that ultimately shape the breast environment.",
    evidenceA: "High level of evidence",
    evidenceB: "Moderate level",
    evidenceC: "Baseline / expert opinion",
    nutrition: "Nutrition",
    mindbody: "Mind & Body",
    activity: "Physical Activity",
    supplements: "Supplements",
    score: "Score",
    factors: "Factors",
    nis_avg: "Avg NIS",
    dil_avg: "Avg DIL",
    meals: "meals",
    last_14: "last 14 days",
    bmi: "BMI",
    age: "Age",
    disclaimerTitle: "Scientific and medical status",
    statusBands: { green: "Protective", yellow: "Average", orange: "Caution", red: "High burden" },
    selectZone: "Select a zone for details",
    refresh: "Refresh data",
    bottomLink: "Go to tools (Risk Profile, BMI, AI mammogram) — educational →",
  },
  es: {
    title: "Breast Health Intelligence",
    subtitle: "Un gemelo digital educativo de la salud mamaria — 6 entornos tisulares, inteligencia metabólica e intervenciones personalizadas",
    description:
      "Integra nutrición, salud metabólica, estilo de vida, biología mamaria y densidad en una sola experiencia educativa. Herramienta educativa y preventiva. No destinada al diagnóstico, tratamiento o predicción del cáncer de mama.",
    back: "Health Intelligence",
    loginCta: "Inicie sesión para acceder al módulo",
    loginCtaText: "Breast Health Intelligence requiere una cuenta segura para proteger los datos de salud.",
    loginBtn: "Iniciar sesión",
    registerBtn: "Registrarse",
    sections: {
      biology:       "Biología del tejido mamario",
      density:       "Inteligencia de densidad",
      metabolic:     "Entorno metabólico",
      benign:        "Afecciones benignas",
      molecular:     "Vías moleculares (educativo)",
      geno_lab:      "🧬 Breast Disease Intelligence",
      tissue_plan:   "🌿 Plan de Restauración del Tejido Mamario",
      prevention:    "🎯 Programa de Prevención de 12 Meses",
      coach:         "🤝 Coach IA de Salud Mamaria",
      interventions: "Intervenciones personalizadas",
      tissue_age:    "Edad del entorno mamario",
      ecosystem:     "Mapa del ecosistema",
      speclab:       "🧪 Detoxificación y genética (DUTCH / ADN)",
    },
    phases: {
      assess:        "Evaluación — quién soy",
      assess_sub:    "Riesgo basal, herencia y puntuación BHI compuesta",
      observe:       "Observación — dónde estoy ahora",
      observe_sub:   "Biología tisular, densidad, entorno metabólico y edad tisular",
      understand:    "Comprensión — qué está pasando biológicamente",
      understand_sub:"Vías moleculares activas y asociaciones biológicas con 23 condiciones",
      plan:          "Plan — qué hacer",
      plan_sub:      "Plan de restauración a corto plazo y estrategia a 12 meses",
      act:           "Acción — mi día a día",
      act_sub:       "Coach mensual dinámico e intervenciones diarias/semanales",
      support:       "Apoyo — herramientas adicionales",
      support_sub:   "Menú compatible con BC y mapa interactivo del ecosistema",
    },
    biologyHelp: "6 entornos anatómicos — un índice educativo de los factores metabólicos/inflamatorios que influyen en cada uno. NO es una medición del tejido.",
    densityHelp: "Categoría BI-RADS A–D del informe escrito de su radiólogo (entrada manual). NO se realiza detección automática por software/IA.",
    metabolicHelp: "Breast Metabolic Score compuesto (0–100) de cinco sub-entornos: insulina, IGF-1, inflamación, estrógeno, adiposidad.",
    benignHelp: "Paneles educativos para las cinco afecciones benignas más comunes con recomendaciones personalizadas.",
    molecularHelp: "Cuatro principales vías de señalización biológica — estrógeno, insulina/IGF-1/mTOR, NF-κB inflamación, oxidativa. Estimaciones educativas, no diagnósticas.",
    interventionsHelp: "Recomendaciones con nivel de evidencia (A/B/C). Educativas — consulte con su médico antes de cambios importantes.",
    tissueAgeHelp: "Métrica educativa — cuánto 'más viejo' o 'más joven' está su entorno metabólico comparado con su edad cronológica.",
    ecosystemHelp: "Cascada de vías biológicas en las que influye el estilo de vida y que finalmente dan forma al entorno mamario.",
    evidenceA: "Alto nivel de evidencia",
    evidenceB: "Nivel moderado",
    evidenceC: "Base / opinión experta",
    nutrition: "Nutrición",
    mindbody: "Cuerpo y mente",
    activity: "Actividad física",
    supplements: "Suplementos",
    score: "Puntuación",
    factors: "Factores",
    nis_avg: "NIS promedio",
    dil_avg: "DIL promedio",
    meals: "comidas",
    last_14: "últimos 14 días",
    bmi: "IMC",
    age: "Edad",
    disclaimerTitle: "Estado científico y médico",
    statusBands: { green: "Protector", yellow: "Medio", orange: "Atención", red: "Alta carga" },
    selectZone: "Seleccione una zona para más detalles",
    refresh: "Actualizar datos",
    bottomLink: "Ir a las herramientas clínicas →",
  },
  // iter1040 — DKG partnership · German localization (core BHI strings).
  // Missing keys fall back to English at consumer level (t.title || en.title).
  de: {
    title: "Brustgesundheits-Intelligenz",
    subtitle: "Personalisierte Analyse, die zeigt, wie verschiedene Prozesse im Körper die Brustgesundheit beeinflussen können. Vereint Erkrankungen, Laborwerte, Ernährung und 20 digitale Gesundheitsmodelle in einer leicht verständlichen interaktiven Karte. Bildungs- und Informationszweck — keine medizinische Diagnose.",
    description:
      "Integriert Ernährung, Stoffwechselgesundheit, Lebensstil, Brustbiologie und Dichte in ein einziges Bildungserlebnis. Bildungs- und Präventionswerkzeug. Nicht zur Diagnose, Behandlung oder Vorhersage von Brustkrebs bestimmt.",
    back: "Health Intelligence",
    loginCta: "Melden Sie sich an, um auf das Modul zuzugreifen",
    loginCtaText: "Brustgesundheits-Intelligenz erfordert ein geschütztes Benutzerkonto zum Schutz Ihrer Gesundheitsdaten.",
    loginBtn: "Anmelden",
    registerBtn: "Registrieren",
    sections: {
      biology:       "Brustgewebe-Biologie",
      density:       "Dichte-Intelligenz",
      metabolic:     "Stoffwechsel-Umgebung",
      benign:        "Gutartige Zustände",
      molecular:     "Molekulare Signalwege (edukativ)",
      geno_lab:      "🧬 Brusterkrankungs-Intelligenz",
      tissue_plan:   "🌿 Plan zur Wiederherstellung des Brustgewebes",
      prevention:    "🎯 12-Monats-Präventionsprogramm",
      coach:         "🤝 Brustgesundheits-Coach KI",
      interventions: "Personalisierte Interventionen",
      tissue_age:    "Metabolisches Brustalter",
      ecosystem:     "Ökosystem-Karte",
      speclab:       "🧪 Entgiftung & Genetik (DUTCH / DNA)",
    },
    phases: {
      assess:        "Bewerten — wer bin ich",
      assess_sub:    "Grundrisiko, erbliche Signale und der zusammengesetzte BHI-Wert",
      observe:       "Beobachten — wo stehe ich gerade",
      observe_sub:   "Gewebebiologie, Dichte, Stoffwechselumgebung und Gewebealter",
      understand:    "Verstehen — was biologisch geschieht",
      understand_sub:"Aktive molekulare Signalwege und biologische Assoziationen mit 23 Erkrankungen",
      plan:          "Planen — was zu tun ist",
      plan_sub:      "Kurzfristiger Wiederherstellungsplan und 12-Monats-Strategie",
      act:           "Handeln — wie ich täglich erscheine",
      act_sub:       "Dynamischer monatlicher Coach und tägliche/wöchentliche Interventionen",
      support:       "Unterstützung — zusätzliche Werkzeuge",
      support_sub:   "BC-freundliches Menü und interaktive Ökosystem-Karte",
    },
    biologyHelp: "6 anatomische Umgebungen — ein edukativer Index der metabolischen/entzündlichen Faktoren, die jede beeinflussen. KEINE Gewebemessung.",
    densityHelp: "BI-RADS A–D-Kategorie aus Ihrem radiologischen Mammographiebericht (manuelle Eingabe). KEINE Software/KI-Dichte-Autodetektion.",
    metabolicHelp: "Zusammengesetzter Brust-Stoffwechsel-Wert (0–100) aus fünf Teilumgebungen: Insulin, IGF-1, Entzündung, Östrogen, Adipositas.",
    benignHelp: "Bildungs-Dashboards für die fünf häufigsten gutartigen Zustände mit personalisierten Empfehlungen.",
    molecularHelp: "Vier wichtige biologische Signalwege — Östrogen, Insulin/IGF-1/mTOR, NF-κB Entzündung, oxidativ. Bildungsschätzungen, nicht diagnostisch.",
    interventionsHelp: "Empfehlungen mit Evidenzgrad (A/B/C). Bildungscharakter — mit Ihrem Arzt vor größeren Änderungen besprechen.",
    tissueAgeHelp: "Bildungsmetrik — wie viel 'älter' oder 'jünger' Ihre Stoffwechselumgebung im Vergleich zu Ihrem chronologischen Alter ist.",
    ecosystemHelp: "Kaskade biologischer Signalwege, die vom Lebensstil beeinflusst werden und letztlich die Brustumgebung formen.",
    evidenceA: "Hohes Evidenzniveau",
    evidenceB: "Mittleres Niveau",
    evidenceC: "Grundlage / Expertenmeinung",
    nutrition: "Ernährung",
    mindbody: "Geist & Körper",
    activity: "Körperliche Aktivität",
    supplements: "Nahrungsergänzung",
    score: "Wert",
    factors: "Faktoren",
    nis_avg: "Ø NIS",
    dil_avg: "Ø DIL",
    meals: "Mahlzeiten",
    last_14: "letzte 14 Tage",
    bmi: "BMI",
    age: "Alter",
    disclaimerTitle: "Wissenschaftlicher und medizinischer Status",
    statusBands: { green: "Schützend", yellow: "Durchschnitt", orange: "Vorsicht", red: "Hohe Belastung" },
    selectZone: "Wählen Sie eine Zone für Details",
    refresh: "Daten aktualisieren",
    bottomLink: "Zu den Werkzeugen (Risikoprofil, BMI, KI-Mammographie) — edukativ →",
  },
};
